<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <HeadlineContainer :headline="project.attributes.name" :breadcrumbs="[{text: 'Projects', url:'/projects'}, {text: project.attributes.name}]">
        <div class="btn-group">
          <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-cogs"></i> Functions <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li>
              <a @click.prevent="copy">
                <i class="fa fa-copy"></i> Copy
              </a>
            </li>
          </ul>
        </div>
      </HeadlineContainer>

      <div class="container">
        <div class="tw-grid tw-grid-cols-4 tw-gap-8">
          <div>
            <div class="panel panel-default">
              <div class="panel-body">
                <div v-if="daysRemaining > 0">
                  <div class="tw-text-center tw-text-8xl">
                    {{ daysRemaining }}
                  </div>

                  <div class="tw-text-center">
                    business days remaining
                  </div>
                </div>

                <div v-else-if="!project.attributes.ends_at">
                  <div class="tw-text-center tw-text-4xl tw-text-yellow-500">
                    The project does not have an end date!
                  </div>
                </div>

                <div v-else>
                  <div class="tw-text-center tw-text-4xl tw-text-green-500">
                    The project is over!
                  </div>
                </div>

                <div class="tw-mt-4 tw-text-gray-400 tw-text-center">
                  <div>
                    Content Deadline: <span v-if="project.attributes.content_deadline_at">{{ project.attributes.content_deadline_at | date }}</span><span v-else>N/A</span>
                  </div>
                  <div>
                    Publication Date: <span v-if="project.attributes.ends_at">{{ project.attributes.ends_at | date }}</span><span v-else>N/A</span>
                  </div>
                </div>
              </div>
            </div>

            <VerticalNavigation :items="navigation"/>
          </div>

          <div class="tw-col-span-3">
            <router-view v-model="project"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import BarsProgressIcon from "../../../../components/Icons/Old/TasksIcon.vue";
import BellIcon from "../../../../components/Icons/Old/BellIcon.vue";
import BullhornIcon from "../../../../components/Icons/Old/BullhornIcon.vue";
import DollarSignIcon from "../../../../components/Icons/Old/DollarSignIcon.vue";
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LoadingContainer from "../../../../components/Layout/LoadingContainer.vue";
import DashboardNavigation from "../../../Administration/Users/Edit/Tabs/Dashboard/DashboardNavigation.vue";
import EditIcon from "../../../../components/Icons/Old/EditIcon.vue";
import PhoneIcon from "../../../../components/Icons/Old/PhoneIcon.vue";
import UsersIcon from "../../../../components/Icons/Old/UsersIcon.vue";
import UserTieIcon from "../../../../components/Icons/Old/UserTieIcon.vue";
import TachometerAltIcon from "../../../../components/Icons/Old/TachometerAltIcon.vue";
import VerticalNavigation from "../../../../components/VerticalNavigation.vue";
import moment from "moment/moment";
import notify from '@/notify'
import BookReaderIcon from "../../../../components/Icons/Old/BookReaderIcon.vue";

export default {
  components: {VerticalNavigation, DashboardNavigation, HeadlineContainer, LoadingContainer},

  data() {
    return {
      project: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    '$route': {
      handler: function () {
        if(this.$route.params.projectId !== this.project.id) {
          this.load()
        }
      },
    },
  },

  computed: {
    navigation() {
      return [
        {name: 'Dashboard', to: '/projects/' + this.project.id + '/dashboard', icon: TachometerAltIcon},
        {name: 'Leads', to: '/projects/' + this.project.id + '/project-leads', icon: PhoneIcon},
        {name: 'Advertisers', to: '/projects/' + this.project.id + '/project-ads', icon: BullhornIcon},
        {name: 'Partners', to: '/projects/' + this.project.id + '/project-partners', icon: BookReaderIcon},
        {name: 'Reminders', to: '/projects/' + this.project.id + '/project-reminders', icon: BellIcon},
        {name: 'Opportunities', to: '/projects/' + this.project.id + '/project-opportunities', icon: DollarSignIcon},
        {name: 'Milestones', to: '/projects/' + this.project.id + '/project-milestones', icon: BarsProgressIcon},
        {name: 'Sales Team', to: '/projects/' + this.project.id + '/project-sellers', icon: UsersIcon},
        {name: 'Managers', to: '/projects/' + this.project.id + '/project-managers', icon: UserTieIcon},
        {name: 'Edit', to: '/projects/' + this.project.id + '/edit', icon: EditIcon},
      ]
    },

    daysRemaining() {
      let current = moment()

      let count = 0

      while (current <= moment(this.project.attributes.ends_at)) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    }
  },

  methods: {
    load() {
      http.get('/api/v2/projects/' + this.$route.params.projectId)
          .then(response => {
            this.project = response.data.data

            this.loading = false
          })
    },

    copy() {
      http.post('/api/v2/projects/' + this.$route.params.projectId + '/copy')
          .then(response => {
            notify.success('The project was copied')

            this.$router.push('/projects/' + response.data.data.id)
          })
    }
  }
}
</script>